export default {"src":"/_next/static/media/GS-NSQ-Logo.0decf121.svg","height":90,"width":89,"blurWidth":0,"blurHeight":0};